<div class="modal-outer-body d-flex flex-column justify-content-between">
    <div class="modal-header d-flex flex-row justify-content-between">
        <div class="h4 p-2">Dialer Issue Report</div>
        <button
            type="button"
            class="close m-0 p-1"
            aria-label="Close"
            (click)="onCancel()"
        >
            <span>&times;</span>
        </button>
    </div>
    <div class="px-1">
        <form class="m-0 p-0" #issueReportForm="ngForm">
            <table class="table table-sm table-striped m-0">
                <thead></thead>
                <tbody>
                    <ng-container *ngIf="versionInfo">
                        <tr>
                            <th>Version</th>
                            <td>
                                <strong>{{ versionInfo.version }}</strong> ({{
                                    versionInfo.git
                                }})
                            </td>
                        </tr>
                        <tr>
                            <th>Process Start Time</th>
                            <td>
                                {{ versionInfo.process_start_time }} (up
                                {{
                                    versionInfo.uptime_minutes | number : "1.3"
                                }}
                                minutes)
                            </td>
                        </tr>
                    </ng-container>
                    <tr>
                        <th class="align-middle">Journalctl Log</th>
                        <td class="align-middle">
                            Since
                            <input
                                type="text"
                                name="journalSince"
                                class="my-1"
                                [disabled]="journalctlProcessing"
                                [(ngModel)]="journalSince"
                            />
                            until
                            <input
                                type="text"
                                name="journalUntil"
                                class="my-1"
                                [disabled]="journalctlProcessing"
                                [(ngModel)]="journalUntil"
                            />
                            <button
                                class="btn btn-sm btn-secondary mx-2 mb-1"
                                [disabled]="journalctlProcessing"
                                (click)="loadJournalCtlLog()"
                            >
                                <i
                                    class="fa {{
                                        journalctlProcessing
                                            ? 'fa-spinner fa-spin'
                                            : 'fa-search'
                                    }}"
                                ></i>
                                Search
                            </button>
                            <span class="text-secondary font-italic small">
                                Journalctl date format (UTC): YYYY-MM-dd
                                HH:MM:SS.sss
                            </span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </form>
    </div>
    <div class="modal-body">
        <div class="alert alert-danger" *ngIf="errorMsg">
            {{ errorMsg }}
        </div>

        <div
            style="white-space: pre"
            class="{{ exportable ? '' : 'text-danger' }}"
        >
            {{ journalCtlLog }}
        </div>
    </div>

    <div class="p-3 d-flex flex-row justify-content-end modal-footer">
        <button
            class="btn btn-primary ml-2"
            title="Submit issue via email"
            [disabled]="!exportable || iProcessingCnt > 0"
            (click)="exportIssueReport()"
        >
            <i
                class="fa {{
                    exportProcessing ? 'fa-spinner fa-spin' : 'fa-download'
                }} mr-2"
            ></i
            >Export
        </button>
        <button class="btn btn-warning" (click)="onCancel()">Close</button>
    </div>
</div>
